import { render, staticRenderFns } from "./AppSafariCard.vue?vue&type=template&id=960ea1b4&scoped=true&"
import script from "./AppSafariCard.vue?vue&type=script&lang=js&"
export * from "./AppSafariCard.vue?vue&type=script&lang=js&"
import style0 from "./AppSafariCard.vue?vue&type=style&index=0&id=960ea1b4&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960ea1b4",
  null
  
)

export default component.exports